<template>
  <Block :title="title" :subtitle="subtitle" :emoji="emoji">
    <div class="px-4 pb-3">
      <div
        v-for="(r, idx) in ranking.slice(0, 3)"
        :key="r.seller.id || idx"
        class="flex items-center gap-3 py-2.5"
        :class="{ 'border-t border-gray-100': idx > 0 }"
      >
        <!-- Avatar + medal pin -->
        <div class="relative size-[38px]">
          <div
            class="w-full h-full rounded-full bg-primary-light text-primary-dark text-[13px] font-bold grid place-items-center"
            :style="{ boxShadow: `0 0 0 2px ${ringColors[idx]}, 0 0 0 4px white` }"
          >
            {{ initials(r.seller.name) }}
          </div>
          <span
            class="absolute -bottom-1 -right-1 grid place-items-center size-4 rounded-full border-[1.5px] border-white text-[9px] text-white font-extrabold"
            :class="rankClass[idx]"
          >
            {{ idx + 1 }}
          </span>
        </div>

        <!-- Name + bar -->
        <div class="flex-1 min-w-0">
          <div class="flex items-baseline justify-between gap-2">
            <div class="font-semibold text-gray-900 text-sm truncate flex items-center gap-1.5 min-w-0">
              <span class="truncate">{{ getFirstName(r.seller.name) }}</span>
              <span
                v-if="showSalesChannel && r.salesChannel"
                class="text-gray-400 text-xs font-normal truncate"
                :title="r.salesChannel"
              >
                · {{ r.salesChannel }}
              </span>
            </div>
            <div class="flex items-baseline gap-2">
              <span v-if="showAmount" class="text-primary-dark font-semibold text-xs tabular-nums">
                {{ formatPrice(r.totalSellerAmount) }}
              </span>
              <span v-if="showAmount" class="text-gray-300 text-[10px]">·</span>
              <span class="text-gray-900 font-bold text-sm tabular-nums">
                {{ $t("roadmap.sales", r.totalRetributions) }}
              </span>
            </div>
          </div>
          <ProgressionBar class="mt-1.5" :max="max" :value="r.totalRetributions || 0" size="h-1.5" />
        </div>
      </div>
    </div>
  </Block>
</template>

<script>
import { Block, formatPrice, ProgressionBar } from "@estaly/ui";

const MEDAL_SHADOW = "shadow-[inset_0_-1px_0_rgba(0,0,0,0.18),0_1px_2px_rgba(0,0,0,0.12)]";

export default {
  name: "PodiumCard",

  components: { Block, ProgressionBar },

  props: {
    title: { type: String, required: true },
    subtitle: { type: String, required: false, default: "" },
    emoji: { type: String, default: "" },
    ranking: { type: Array, default: () => [] },
    showAmount: { type: Boolean, default: true },
    showSalesChannel: { type: Boolean, default: false },
  },

  data() {
    return {
      ringColors: ["#F4C53A", "#C9C9CE", "#C98B5A"],
      rankClass: [
        `bg-linear-to-b/srgb from-[#ffd86b] to-[#e0a500] ${MEDAL_SHADOW}`,
        `bg-linear-to-b/srgb from-[#dcdcdc] to-[#9a9a9a] ${MEDAL_SHADOW}`,
        `bg-linear-to-b/srgb from-[#e0a372] to-[#a0653b] ${MEDAL_SHADOW}`,
      ],
    };
  },

  computed: {
    max() {
      return Math.max(1, ...this.ranking.slice(0, 3).map((r) => r.totalRetributions || 0));
    },
  },

  methods: {
    formatPrice,

    getFirstName(fullName) {
      if (!fullName) return "";
      return fullName.split(" ")[0];
    },

    initials(name) {
      if (!name) return "";
      return name
        .split(/\s+/)
        .map((p) => p[0])
        .filter(Boolean)
        .slice(0, 2)
        .join("")
        .toUpperCase();
    },
  },
};
</script>
